import React from 'react';

const SurveyStatCard = ({ title, value, subtext, icon, solid = false, tone }) => {
  return (
    <div className="col-xl-3 col-lg-6 col-md-6 mb-4">
      <div className={`survey-stat-tile ${solid ? 'survey-stat-tile-solid' : ''}`}>
        <div className="survey-stat-tile-header">
          <span className="survey-stat-tile-icon">{icon}</span>
          <span>{title}</span>
        </div>
        <div className={`survey-stat-tile-value ${tone ? `tone-${tone}` : ''}`}>{value}</div>
        <div className="survey-stat-tile-subtext">{subtext}</div>
      </div>
    </div>
  );
};

export default SurveyStatCard;
